import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  CssBaseline,
  Toolbar,
  Breadcrumbs,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header_new";
import AppSidebar from "./UnifiedSidebar";
import Footer from "../components/Footer/Footer";
import { useAuth, useCurrentTalentProfile } from "../hooks";
import SocketHandler from "../utils/socketHandler";
import {
  getTalentSocketNotification,
  getUserSocketNotification,
} from "../utils/notificationHandler";
import { playNotificationSound } from "../utils/notificationSound";

const MainLayout: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { currentProfile } = useCurrentTalentProfile();

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const CreateCard = () =>
    currentProfile?.user?.talent
      ? navigate("/create-card")
      : navigate("/create-card");

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const buildPath = (index: number) =>
    "/" + pathSegments.slice(0, index + 1).join("/");

  const [badgeVisible, setBadgeVisible] = useState(false);

  const [socketNotification, setSocketNotification] = useState<any>([]);
  const { userInfo } = useAuth();

  const socketSubscribedRef = useRef(false);
  useEffect(() => {
    // Prevent multiple subscriptions
    if (socketSubscribedRef.current || !userInfo?.id) {
      return;
    }

    try {
      // Get socket instance and subscribe to messages
      const socketHandler = SocketHandler.getInstance();

      socketHandler.subscribeToNotification(
        userInfo.id.toString(),
        (message) => {
          if (message) {
            const notification = currentProfile?.id
              ? getTalentSocketNotification(message, currentProfile?.id)
              : getUserSocketNotification(message);
            if (notification) {
              setSocketNotification((prev: any) => [...prev, notification]);
              setBadgeVisible(true);
              playNotificationSound();
            }
          }
          // Handle the message here
        }
      );

      socketSubscribedRef.current = true;
      console.log("Successfully subscribed to notification socket");
    } catch (error) {
      console.error("Failed to subscribe to socket:", error);
    }

    // Cleanup subscription when component unmounts
    return () => {
      try {
        if (userInfo?.id) {
          const socketHandler = SocketHandler.getInstance();
          socketHandler.unsubscribeFromNotification(userInfo.id.toString());
          socketSubscribedRef.current = false;
          console.log("Successfully unsubscribed from notification socket");
        }
      } catch (error) {
        console.error("Failed to unsubscribe from socket:", error);
      }
    };
  }, [userInfo?.id]);
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* Header and Sidebar */}
      <Header
        toggleDrawer={toggleDrawer}
        onClickCreate={CreateCard}
        setBadgeVisible={setBadgeVisible}
        badgeVisible={badgeVisible}
        socketNotification={socketNotification}
      />
      <AppSidebar open={drawerOpen} setDrawerOpen={setDrawerOpen} />

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          px: { xs: 1, md: 3 },
          py: 3,
          overflow: "hidden",
        }}
      >
        <Toolbar />

        {/* Breadcrumb Navigation */}
        {/* <Breadcrumbs sx={{ mb: 2 }}>
          <MuiLink
            underline="hover"
            color="inherit"
            onClick={() => navigate("/")}
            sx={{ cursor: "pointer" }}
          >
            Home
          </MuiLink>

          {pathSegments.map((seg, idx) => {
            const isLast = idx === pathSegments.length - 1;
            const label = seg.charAt(0).toUpperCase() + seg.slice(1);

            return isLast ? (
              <Typography key={idx} color="text.primary">
                {label}
              </Typography>
            ) : (
              <MuiLink
                key={idx}
                underline="hover"
                color="inherit"
                onClick={() => navigate(buildPath(idx))}
                sx={{ cursor: "pointer" }}
              >
                {label}
              </MuiLink>
            );
          })}
        </Breadcrumbs> */}

        <Box sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default MainLayout;
